import { updateItems } from '@/mocks/home';

export default function Updates() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">更新动态</h2>
          <p className="text-sm md:text-base text-foreground-500">最新漫画资源与功能动态，实时掌握平台变化</p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="relative pl-8 border-l-2 border-primary-200">
            {updateItems.map((item, idx) => (
              <div key={idx} className={`relative pb-8 ${idx === updateItems.length - 1 ? 'pb-0' : ''}`}>
                <div className="absolute -left-[25px] top-0 w-3 h-3 rounded-full bg-primary-500 border-2 border-background-100"></div>
                <div className="bg-background-50 rounded-xl p-4 md:p-5">
                  <div className="flex flex-wrap items-center gap-2 mb-2">
                    <span className="text-xs px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 font-medium whitespace-nowrap">
                      {item.tag}
                    </span>
                    <span className="text-xs text-foreground-500">{item.date}</span>
                  </div>
                  <p className="text-sm md:text-base text-foreground-800 leading-relaxed">{item.title}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}